import { ObserverItem } from "@core/libs/observer";

export {};

// Live-streams Splide instance. Tracked so refreshLiveStreams can destroy the
// previous instance before re-mounting, instead of stacking instances every 30s.
let streamsSplide: any = null;

document.addEventListener('started', (event: Event) => {
    mountSliders();
    startLiveStreamsUpdater();

    app.voyo.playTrailer('#content .media');
});

document.addEventListener('started-user', (event: Event) => {
    app.html.removeClass('.stream_reminder', 'hidden');
});

// Starts periodic check for new live stream data
function startLiveStreamsUpdater(): void {
    const liveStreamsBox = app.html.q('#voyobox_streams');
    if (!liveStreamsBox || typeof Splide === 'undefined') {
        return;
    }

    setTimeout(refreshLiveStreams, 30000);
}

// Fetches and updates live stream data every 30 sec
function refreshLiveStreams(): void {
    app.voyo.refreshStreams()
        .then(([needsUpdate, html]) => {
            const dest = app.html.q('#voyobox_streams .track');

            if (needsUpdate && dest) {
                streamsSplide?.destroy(true);
                app.html.writeHTML(dest, html);
                streamsSplide = new Splide('#voyobox_streams').mount();
            }

            setTimeout(refreshLiveStreams, 30000);
        });
}

function mountSliders(): void {
    if (typeof Splide === 'undefined') {
        return;
    }

    // Loop through all splides and mount() them
    app.html.qAll('.splide')
        .forEach((splideEl: HTMLElement, i: number) => {
            app.observer.observe(splideEl, { task: 'mountVoyoSplide', params: {} });
        });
}

function mountVoyoSplide(item: ObserverItem): void {
    const splide = new Splide(item.element).mount();

    // Keep a handle to the streams slider so refreshLiveStreams can destroy it
    // before re-mounting. Other sliders don't need tracking.
    if (item.element.id === 'voyobox_streams') {
        streamsSplide = splide;
    }
}

function muteUnmuteTrailerVolume(event: Event) {
    if (!window.app) {
        return;
    }

    app.voyoVideo.muteUnmuteTrailerVolume(event);
}

// Opens the player overlay on this page (no navigation) and starts playback.
// startAt: 0 plays live, >0 plays from that second.
function playStreamInPlace(startAt: number): void {
    if (!window.app) {
        return;
    }

    if (app.playRestriction.restrictAppPlayback()) {
        return;
    }

    app.html.addClass('body', 'playing_content');

    const mediaId = app.html.getData('#stream_play video', 'mediaId');
    playStream(mediaId, startAt);
}

function playStream(mediaId: string, startAt?: number): void {
    if (!window.app) {
        return;
    }

    app.voyoVideo.stopVideoPlayers();
    app.voyoVideo.initForPlay('.player_box video', +mediaId, {startAt})
        .then(() => {
            app.html.q('.player')?.focus();
        });
}

function playSubStream(event: Event, mediaId: string): void {
    event.preventDefault();
    event.stopPropagation();

    if (!window.app) {
        return;
    }

    playStream(mediaId);

    app.html.removeClass('.button-stream', 'button-stream__active');
    app.html.addClass(event.target as HTMLElement, 'button-stream__active');
}

function streamIconHover(event: Event): void {
    if (!window.app) {
        return;
    }

    const title = app.html.getData(event.target as HTMLElement, 'title') || '';
    const titleEl = app.html.q('#substream_text');

    if (titleEl) {
        titleEl.innerHTML = title;
    }
}

window.addEventListener('beforeunload', () => {
    if (window.app) {
        app.voyoVideo.stopVideoPlayers();
    }
});

window.muteUnmuteTrailerVolume = muteUnmuteTrailerVolume;
window.mountVoyoSplide = mountVoyoSplide;
window.playStreamInPlace = playStreamInPlace;
window.playStream = playStream;
window.playSubStream = playSubStream;
window.streamIconHover = streamIconHover;